"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var Sentry = __importStar(require("@sentry/browser"));
var ErrorRecorder = (function () {
    function ErrorRecorder(projectId, blockId) {
        this.projectId = projectId;
        this.blockId = blockId;
        this.debouncedSend = lodash_1.default.debounce(this.sendToSentry, 300);
    }
    ErrorRecorder.prototype.recordError = function (error, additionalContext, additionalTags) {
        if (additionalContext === void 0) { additionalContext = {}; }
        if (additionalTags === void 0) { additionalTags = {}; }
        this.debouncedSend(error, additionalContext, additionalTags);
    };
    ErrorRecorder.prototype.sendToSentry = function (error, additionalContext, additionalTags) {
        Sentry.captureException(error, {
            tags: __assign(__assign({}, additionalTags), { projectId: this.projectId, blockId: this.blockId, slateVersion: "05x" }),
            extra: additionalContext,
        });
    };
    return ErrorRecorder;
}());
exports.default = ErrorRecorder;
